module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAM1BMVEVBid1Ei95FjN5Ijd5Okd9SlOBjnuN0qOaszPCwzvHA2PTJ3fXL3/bW5vj2+f35+/7///8DzmnuAAAAOUlEQVQYGd3BBwEAIAwEsWOWDf7VouARQMIvnOPFjJdakVKba82WEOI4Z0SksndB6zl3JB8geL5wAT6JARGjwUDYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/so.png
// module id = 385
// module chunks = 0